import React from "react";

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <React.Fragment>
        <section id="map-sedona-hiking" className="about-us gray-light-bg">
          <iframe
            src="https://maps.google.com/maps?saddr=Cathedral+Rock+Trailhead,+Sedona,+AZ&daddr=Red+Rock+Crossing,+Sedona,+AZ+to:Airport+Mesa,+Sedona,+AZ+to:Bell+Rock,+Sedona,+AZ+to:Devils+Bridge+Trailhead,+Sedona,+AZ+to:Courthouse+Butte+Loop+Trailhead,+Sedona,+AZ+to:Slide+Rock+State+Park,+AZ&output=embed"
            width="100%"
            height="420">
          </iframe>
        </section>
      </React.Fragment>
    );
  }
}

export default About;
